import { makeLogger } from '../../../../logger/logger';
import { waitForLock } from '../../../../utils/critical-section';
import { withStore } from '../../../../utils/memoize';
import { authenticationHeaders } from '../../../guided/subcomponents/utils';
import type { IWidgetData } from '../offsites-widget-v4/types/offsites-widget-v4.types';

const { err } = makeLogger({
  pathToCurrentFile:
    'components/widgets/offsites-widget/offsites-widget-v2/widget-logic/offsites-widget-v2-actions.tsx',
  loggersList: ['err'],
});

type Headers = Record<string, string>;

export const createUrl = (endpoint: string) => {
    try {
      const url = new URL(endpoint);
      url.searchParams.append('ui-component', 'widget-offsites-v3');
      return url.href;
    } catch (e) {
      err(`unable to create url from  ${endpoint}`);
      return '';
    }
};

export const fetchOffsiteBannersManagerData = async function (data) {
    const { term, country, language, brand, apiEndpoint, apigeeAuth, apigeeTokenUrl, idmsToken, apikey } =
    data;

    const url = createUrl(apiEndpoint);
    const clearedBrand = brand?.trim().toLowerCase();

    const authHeaders = await authenticationHeaders({
      apigeeBasicAuth: apigeeAuth,
      tokenUrl: apigeeTokenUrl,
      idmsToken,
      apikey
    });

    const headers: Headers = {
      'Content-type': 'application/json; charset=utf-8',
      ...authHeaders,
    };

    const requestBody = {
      searcher: `${clearedBrand}/banner`,
      country: country,
      language: language,
      term: term,
    };

    return await waitForLock({
      interval: 50,
      maxDelay: 10000,
      executeAfterTimeout: true,
      cbk: async () => {
          return await withStore({
            cbkArgs: requestBody,
            cbk: async (requestData) => {
                try {
                  const request = new Request(url, {
                    method: 'POST',
                    body: JSON.stringify(requestData),
                    headers: headers,
                  });
                  const res = await fetch(request);
                  const json = await res.json();
                  return json?.documents?.[0] as IWidgetData;
                } catch (e) {
                  err('Failed to fetch data from Banners Manager API', e);
                  return null;
                }
            },
          });
      },
    });
};
